import BoxKit from "@/shared/components/kit/box";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import GpsFixedOutlinedIcon from "@mui/icons-material/GpsFixedOutlined";
import { useNavigate } from "react-router";
/**
 * TwentyCardCenters
 *
 * کامپوننت نمایش مراکز بیست کارت شامل گیشه‌ها و پذیرنده‌ها.
 * دارای دکمه‌های دسترسی به نقشه برای هر نوع مرکز است.
 *
 * @returns JSX.Element
 */

const TwentyCardCenters = () => {
  const navigate = useNavigate()
  return (
    <CardKit
      width={"100%"}
      height={204}
      title={
        <StackKit direction={"row"} justifyContent={"space-between"}>
          <StackKit direction={"row"} gap={1}>
            <FmdGoodOutlinedIcon style={{ color: "#fff" }} />
            <TypoGraphyKit>مراکز بیست کارت</TypoGraphyKit>
          </StackKit>
        </StackKit>
      } sx={{ background:"linear-gradient(153.86deg, rgba(0, 0, 0, 0.4) -11.84%, rgba(37, 37, 37, 0.370427) 14.24%, rgba(78, 78, 78, 0.340413) 40.7%, rgba(0, 0, 0, 0.237218) 75.66%, rgba(0, 0, 0, 0.12) 106.2%)", backdropFilter: " blur(242.1999969482422px)", boxShadow: "-3px 0px 24px -3px #00000078",}}>
      <StackKit sx={{ width: "100%", justifyContent: "center", alignItems: "center" }} gap={1}>
        <StackKit sx={{width: "100%",background:"linear-gradient(91.84deg, rgba(255, 255, 255, 0.123) -11.9%, rgba(255, 255, 255, 0.027) 109.66%)",cursor:'pointer',height: "40px",flexDirection: "row",alignItems: "center",justifyContent: "space-between",padding: "10px 30px",borderRadius: "10px",}} onClick={()=>navigate("/locations")}>
          <TypoGraphyKit variant="body1">لیست مراکز گیشه</TypoGraphyKit>
          <BoxKit sx={{ height: "100%", marginTop: "0!important" }}>
            <GpsFixedOutlinedIcon style={{ color: "#fff", margin: "0!important",cursor:"pointer" }} />
          </BoxKit>
        </StackKit>
        <StackKit sx={{width: "100%",background:"linear-gradient(91.84deg, rgba(255, 255, 255, 0.123) -11.9%, rgba(255, 255, 255, 0.027) 109.66%)",cursor:'pointer',height: "40px",flexDirection: "row",alignItems: "center",justifyContent: "space-between",padding: "10px 30px",borderRadius: "10px",}} onClick={()=>navigate("/locations/merchant")}>
          <TypoGraphyKit variant="body1">لیست مراکز پذیرنده</TypoGraphyKit>
          <BoxKit sx={{ height: "100%", marginTop: "0!important" }}>
            <GpsFixedOutlinedIcon style={{ color: "#fff", margin: "0!important",cursor:"pointer" }} />
          </BoxKit>
        </StackKit>
      </StackKit>
    </CardKit>
  );
};

export default TwentyCardCenters;
